import SolidSpinnerIcon from "../../../assets/icons/SolidSpinnerIcon";
import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../ui/dialog";
import { Input } from "../../ui/input";
import React from "react";

const PinDashboardDialog = ({
  onChange,
  value,
  title,
  description,
  children,
  handleSubmit,
  isLoading,
  isDialogOpen,
  setIsDialogOpen,
  actionButtonName = "Create",
}) => {
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px] bg-zinc-900 border-zinc-800">
        <DialogHeader>
          <DialogTitle className="text-zinc-100">{title}</DialogTitle>
          <DialogDescription className="text-zinc-300">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Input
            id="name"
            onChange={onChange}
            value={value}
            className="col-span-3 border-indigo-500"
          />
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="gap-1 items-center bg-zinc-100 hover:bg-zinc-50 text-zinc-800 shadow-none"
            onClick={handleSubmit}
          >
            {isLoading ? (
              <div>
                <SolidSpinnerIcon className="w-4 h-4 animate-spin" />
              </div>
            ) : null}
            {actionButtonName}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PinDashboardDialog;
